import type { FC, ReactElement } from 'react';

import { useModifiers } from '../../../../styles/hooks/useModifiers';
import { Tooltip } from '../../../tooltip/Tooltip';
import { ChipStackButton } from '../chipStackButton';
import type { BarChipStackProps } from '../types';

import styles from './barChipStack.module.css';

export const BarChipStack: FC<BarChipStackProps> = ({
  chips,
  disabled,
  onChipSelect,
  selectedChip,
  vertical,
}): ReactElement => {
  const mods = useModifiers(styles, 'barChipStack', { disabled, vertical });
  return (
    <div className={`${styles.barChipStack} ${mods}`}>
      {chips.map((chip) => (
        <Tooltip
          text="INSUFFICIENTFUNDS"
          disabled={!chip.disabled || chip.toolTipDisabled || disabled}
          displayOnTouch
          key={chip.weight}
        >
          <ChipStackButton
            active={selectedChip?.weight === chip.weight}
            chip={chip}
            disabled={chip.disabled || disabled}
            fidget
            grow
            onChipSelect={onChipSelect}
          />
        </Tooltip>
      ))}
    </div>
  );
};
